import axios from "axios";
import authUtil from "../utils/AuthUtils";
import { getServiceApiKey } from "../utils/apiKey";

const BASE_API_URL = `${ window?.appConfig?.API_ENDPOINT }`;

const getConfig = async () => {
  const token = await authUtil.getDocumentServiceToken();
  return {
    headers: {
      "x-api-key": getServiceApiKey(),
      "x-document-service-integration-token": token,
    },
  };
};

async function uploadJsonTemplate(requestObj) {
  const config = await getConfig();  // Await the token asynchronously
  return axios.post(BASE_API_URL + `/jsonTemplates`, requestObj, {
    headers: {
      ...config.headers,
      "Content-Type": "multipart/form-data"
    }
  });
}

async function updateJsonTemplate(templateId, requestObj) {
  const config = await getConfig();  // Await the token asynchronously
  return axios.put(BASE_API_URL + `/jsonTemplates/` + templateId, requestObj, {
    headers: {
      ...config.headers,
      "Content-Type": "multipart/form-data"
    }
  });
}

async function getAllJsonTemplates() {
  const config = await getConfig();  // Await the token asynchronously
  return axios.get(BASE_API_URL + `/jsonTemplates`, config);
}

async function getJsonTemplateById(templateId){
  const config = await getConfig();  // Await the token asynchronously
  return axios.get(BASE_API_URL + `/jsonTemplates/`+templateId, config);
}

async function deleteJsonTemplate(templateId) {
  const config = await getConfig();  // Await the token asynchronously
  return axios.delete(BASE_API_URL + `/jsonTemplates/` + templateId, config);
}

export default {
  uploadJsonTemplate,
  updateJsonTemplate,
  getAllJsonTemplates,
  getJsonTemplateById,
  deleteJsonTemplate
};
